/**
 * ブラウザ側の設定（Vite の環境変数 VITE_* から読む）。
 * ここに入る値はすべてブラウザに公開される。秘密のキーは functions/ 側（.dev.vars / Pages Secrets）へ。
 */
export type TileSource = 'openfreemap' | 'maptiler' | 'pmtiles';

const env = import.meta.env;

export const config = {
  tileSource: ((env.VITE_TILE_SOURCE as string) || 'openfreemap') as TileSource,
  maptilerKey: (env.VITE_MAPTILER_KEY as string) || '',
  pmtilesUrl: (env.VITE_PMTILES_URL as string) || '',
  /** 初期表示位置（東京駅付近） */
  initialCenter: [139.7671, 35.6812] as [number, number],
  initialZoom: 15,
};
